export const DataTypeField = {
  directDebits: 'directDebits',
  receivedPayments: 'receivedPayments',
  debitsAndDeposits: 'debitsAndDeposits',
  scheduledTransaction: 'scheduledTransaction',
  standingOrders: 'standingOrders',
  balanceList: 'balanceList',
  custom: 'custom',
};

/*
 * WARNING:
 * The property 'upload' is the name of the specific upload function in the controller but also
 * the property name of an array holding a file list. If you add a new UploadField calling the
 * same upload function an other UploadField uses make sure only one of these UploadFields is used.
 * Otherwise multiple UploadFields refer to the same file array which causes an InfDig.
 * */
export const UploadFields = {
  [DataTypeField.directDebits]: {
    label: 'app.ticket.upload.directDebits',
    upload: 'uploadSepaDirectDebits',
  },
  [DataTypeField.receivedPayments]: {
    label: 'app.ticket.upload.receivedPayments',
    upload: 'uploadReceivedPayments',
  },
  [DataTypeField.debitsAndDeposits]: {
    label: 'app.ticket.upload.debitsAndDeposits',
    upload: 'uploadSepaDirectDebits',
  },
  [DataTypeField.balanceList]: {
    label: 'app.ticket.upload.balanceList',
    upload: 'uploadBalanceList',
  },
  [DataTypeField.scheduledTransaction]: {
    label: 'app.ticket.upload.scheduledTransaction',
    upload: 'uploadScheduledTransaction',
  },
  [DataTypeField.standingOrders]: {
    label: 'app.ticket.upload.standingOrder',
    upload: 'uploadStandingOrders',
  },
  [DataTypeField.custom]: {
    label: 'app.ticket.upload.custom',
    upload: 'uploadCustomBalanceList',
  },
};

export const ManualDataTypesByTenant = (tenant) => {
  return tenant === 'volkswagenbank' || tenant === 'audibank'
    ? [DataTypeField.standingOrders]
    : [];
};
